export const ADD_EDITOR_DATA = "ADD_EDITOR_DATA"
export const ADD_EDITOR_DATA_SUCCESS = "ADD_ACCOUNT_HOLDER_SUCCESS"
export const ADD_EDITOR_DATA_FAIL = "ADD_ACCOUNT_HOLDER_FAIL"
export const CLEAR_EDITOR_DATA = "CLEAR_EDITOR_DATA"

export const GET_EDITOR_DATA = "GET_EDITOR_DATA"
export const GET_EDITOR_DATA_SUCCESS = "GET_EDITOR_DATA_SUCCESS"
export const GET_EDITOR_DATA_FAIL = "GET_EDITOR_DATA_FAIL"
